import React, { useState, useEffect } from 'react';
import Axios from '../../config/axios';
import { toast, confirm } from '@rickylandino/react-messages';
import Moment from 'moment';
import { dateWithNoTimezone } from './DateFormat';
import { useForm, Controller } from "react-hook-form";
import { Modal, Empty, Spin, Select, Alert, Table, Space, Checkbox, List } from 'antd';
import ReactLoading from 'react-loading';
import { Fragment } from 'react';

export default function SelectContactsModal(props) {
    const { register, getValues, setValue, control, watch } = useForm();

    const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));

    const { Option } = Select;

    const [state, setState] = useState({
        showModal: props.showModal,
        loading: true
    });

    const [sendTestEmail, setSendTestEmail] = useState([false]);
    const [checked, setChecked] = useState([]);
    const [buttonText, setButtonText] = useState(['']);

    useEffect(() => {
        setState({
            ...state,
            loading: true
        });

        getCompanyContacts(props.selectedCustomerId, userInfo.jobShopDivision);

        switch (props.opMode) {
            case 'NewExhibitorEmail_ButtonClick':
            case 'NewExhibitorEmail_SalesStatusChange':
                setButtonText('Send New Exhibitor Email');
                break;
            case '':
                // code block
                break;
            default:
            // code block
        }
    }, [props]);

    function getCompanyContacts(company_id, jobshopdivision) {
        var currContact;
        var myCheckedContacts = [];

        let postdata = {};
        postdata.company_id = company_id;
        postdata.jobshopdivision = jobshopdivision;

        Axios.post(`/api/GetCompanyContacts`, postdata
        ).then(response => {
            let contacts = response.data;

            for (let i = 0; i < contacts.length; i++) {
                currContact = contacts[i];

                if (currContact.contact_type === 'Main' || currContact.contact_type === 'Logistics' || currContact.contact_type === 'Alt Sales') {
                    myCheckedContacts = [...myCheckedContacts, currContact.email];
                }
            }
            setChecked(myCheckedContacts);

            setSendTestEmail(false);

            setState({
                ...state,
                contacts,
                dataLoaded: true,
                showContactDetailsSlider: false,
                loading: false
            });

        }).catch(error => {
            console.log(error);
        });
    }

    function closeModal() {
        //trigger save of changes made on show detail slider
        if (props.opMode === 'NewExhibitorEmail_SalesStatusChange') {
            props.saveShowDetailRecord();
        }

        //This prevents the modal from opening in the parent unless called upon again
        props.hideSelectShowModal();

        setState({
            ...state,
            showModal: false
        });
    }

    function openModal() {
        setState({
            ...state,
            showModal: true
        });
    }

    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    function onSelectContacts() {
        if (sendTestEmail === true) {
            if (isValidEmail(getValues().testEmailRecipient) === false) {
                toast.error('Invalid email address');
                return;
            }

            props.sendNewExhibitorEmail(getValues().testEmailRecipient);
        }
        else {
            props.sendNewExhibitorEmail(checked.join(", "));
        }

        //This prevents the modal from opening in the parent unless called upon again
        props.hideSelectShowModal();

        setState({
            ...state,
            showModal: false
        });
    }

    const handleSendTestEmailChange = (event) => {
        setSendTestEmail(event.target.checked);
    };

    return (
        <>
            <Modal
                visible={state.showModal}
                title={state.modalTitle}
                onCancel={closeModal}
                footer={[
                    <button className="btn btn-submit" onClick={onSelectContacts}>
                        {buttonText}
                    </button>,
                    <span>&nbsp;&nbsp;</span>,
                    <button className="btn btn-outline-primary" onClick={closeModal}>
                        Close
                    </button>
                ]}
            >
                <h5>Select Contacts</h5>
                {state.loading ?
                    <ReactLoading className='tableLoading' type={"spokes"} color={'Navy'} width={30}
                        style={{ display: 'flex', alignItems: 'center', height: '100%', margin: '0 auto', width: '30px', fill: '#6FB246' }}
                    />
                    :
                    <Fragment>
                        {
                            state.contacts.length > 0 ?
                                <>
                                    <Checkbox.Group
                                        style={{ width: "100%" }}
                                        value={checked}
                                        onChange={(checkedValues) => {
                                            console.log(checkedValues);
                                            setChecked(checkedValues);
                                        }}
                                    >
                                        <List
                                            itemLayout="horizontal"
                                            dataSource={state.contacts}
                                            renderItem={(item) => (
                                                <List.Item>
                                                    <List.Item.Meta
                                                        avatar={<Checkbox value={item.email} />}
                                                        title={item.jsS_name + ' (' + item.contact_type + ')'}
                                                        description=''
                                                    />
                                                </List.Item>
                                            )}
                                        />
                                    </Checkbox.Group>
                                    {/*
                                    <div style={{ marginTop: 20 }}>
                                        <b>Selecting:</b> {checked.join(", ")}
                                    </div>
                                    */}
                                </>
                                :
                                <Empty description={<p>No Contacts Found</p>} />
                        }
                        <hr />
                        <div className="custom-control custom-checkbox">
                            <input type="checkbox" className="custom-control-input" name="sendtestemail" checked={sendTestEmail} onChange={handleSendTestEmailChange} />
                            <label className="custom-control-label">Send Test Email</label>
                        </div>
                        <div className="form-group col-12">
                            <input className="ant-input" {...register('testEmailRecipient')} />
                        </div>
                    </Fragment>
                }
                
            </Modal>
        </>
    );
}